import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { useTranslation } from 'react-i18next';

const Result = () => {
  const { t } = useTranslation();
  return (
    <Alert variant="success" className="success-msg">
      {t('Your Message has been successfully sent.')}
    </Alert>
  );
};

const FormOne = () => {
  const { t } = useTranslation();
  const [result, showResult] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    formData.append('accessKey', 'sf_2h41a6k81db1m14mi6b5j69e');

    try {
      const response = await fetch('https://api.staticforms.xyz/submit', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        e.target.reset();
        showResult(true);
        setTimeout(() => showResult(false), 5000);
      } else {
        console.error('StaticForms submission failed.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <form className="axil-contact-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <div className="row">
          <div className="col-md-6">
            <label htmlFor="contact-name">{t('Nom')}</label>
            <input
              type="text"
              className="form-control"
              name="name"
              id="contact-name"
              placeholder="Sousa"
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="contact-surname">{t('Prénom')}</label>
            <input
              type="text"
              className="form-control"
              name="surname"
              id="contact-surname"
              placeholder="João"
              required
            />
          </div>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="contact-email">{t('Email')}</label>
        <input
          type="email"
          className="form-control"
          name="email"
          id="contact-email"
          placeholder="example@mail.com"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="contact-phone">{t('Téléphone')}</label>
        <input
          type="tel"
          className="form-control"
          name="phone"
          id="contact-phone"
          placeholder="+41 12 345 67 89"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="contact-message">{t('Message')}</label>
        <textarea
          className="form-control"
          name="message"
          id="contact-message"
          placeholder={t('Your message')}
          required
        ></textarea>
      </div>

      <div className="form-group">
        <button
          type="submit"
          className="axil-btn btn-fill-primary btn-fluid btn-primary dark_text_color"
          name="submit-btn"
        >
          {t('Envoyer')}
        </button>
      </div>

      <div className="form-group">{result ? <Result /> : null}</div>
    </form>
  );
};

export default FormOne;
